import axios from './api';

export default function depositHistory(params) {
    return new Promise((resolve, reject) => {
        axios.get("wallet/depositTransaction", {
            params: {
                page: params.currentPage,
                size: params.pageSize,
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


